import { Fragment } from "@wordpress/element";
import { InspectorControls, RichText, URLInput, URLInputButton  } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';

const attributes = {
  title: {
    type: 'string',
  },
  link: {
    type: 'string',
  },
  opensInNewWindow: {
    type: 'boolean',
    default: false,
  }
};

const Link = {
  title: __('Link'),
  description: __('Link content block for the ABS theme'),
  icon: 'admin-links',
  attributes: attributes,
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes, isSelected }) {
    const { title, link, opensInNewWindow } = attributes;

    const toggleTargetWindow = () => {
      setAttributes( { opensInNewWindow: !opensInNewWindow } );
    };

    const onChangeUrl = (url) => {
      setAttributes( { link: url } );
    }


    return (
      <Fragment>
        <div className={className}>
          <div className="linksection__header">
            <div className="linksection__header__label">
              <RichText
                tagName="h2"
                value={ title }
                placeholder={ __('Insert link title') }
                allowedFormats={[]}
                onChange={nextTitle => setAttributes({ title: nextTitle })}
              />
              <URLInputButton
                url={ link }
                onChange={ onChangeUrl }
              />
            </div>
          </div>
        </div>

        <InspectorControls>
          <PanelBody title={ __('Link Options') }>
            <PanelRow>
              <URLInput
                className={'url-input'}
                label={ __('URL') }
                value={ link }
                onChange = { onChangeUrl }
              />
            </PanelRow>
            <PanelRow>
              <ToggleControl
                label={ __('Open link in new window') }
                help={ opensInNewWindow ? __('In new window') : __('In same window') }
                checked={ !! opensInNewWindow }
                onChange={ toggleTargetWindow }
              />
            </PanelRow>
          </PanelBody>
        </InspectorControls>

      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { title, link, opensInNewWindow } = attributes;

    return (
      <div className={ className }>
        <a className="linksection__header" href={ link } target={ (opensInNewWindow) ? '_blank':'_self' }>
          <div className="linksection__header__label">
            {title && (
                <RichText.Content tagName="h2" value={ title } />
            )}
            <span className="icon icon-chevron-right"></span>
          </div>
        </a>
      </div>
    );
  },

  deprecated: [
    {
      attributes,
      save({ className, attributes }) {
        const { title, link } = attributes;

        return (
          <div className={ className }>
            <a className="linksection__header" href={ link }>
              <div className="linksection__header__label">
                {title && (
                  <RichText.Content tagName="h2" value={ title } />
                )}
                <span className="icon icon-chevron-right"></span>
              </div>
            </a>
          </div>
        );
      },
    }
  ]
};

export default Link;
